module.exports = __webpack_public_path__ + "assets/9933c903cef8514cc7e47d0b3d59be5c.mp3";